var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.063,
    height: 18.712,
    viewBox: "0 0 24.063 18.712",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.711,7.108l-7.7,6.343V20.3a.668.668,0,0,0,.668.668l4.681-.012a.668.668,0,0,0,.665-.668v-4a.668.668,0,0,1,.668-.668h2.673a.668.668,0,0,1,.668.668v4a.668.668,0,0,0,.668.67l4.679.013a.668.668,0,0,0,.668-.668V13.446l-7.7-6.339A.509.509,0,0,0,11.711,7.108Zm12.165,4.311L20.384,8.541V2.755a.5.5,0,0,0-.5-.5H17.544a.5.5,0,0,0-.5.5V5.788L13.3,2.711a2.005,2.005,0,0,0-2.548,0L.181,11.419a.5.5,0,0,0-.067.706L1.179,13.42a.5.5,0,0,0,.706.068L11.711,5.4a.509.509,0,0,1,.639,0l9.826,8.093a.5.5,0,0,0,.706-.067l1.065-1.295a.5.5,0,0,0-.071-.707Z",
    transform: "translate(0.001 -2.254)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.77671b19.svg";
export { ForwardRef as ReactComponent };